import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SignInComponent } from './sign-in.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '', component: SignInComponent,
      },
    ])],
  exports: [RouterModule]
})
export class SignInRoutingModule { }

/**
 * User redirection if access to user adding screen is not allowed
 */
export function userAddRedirectTo() {
  console.log('Access Denied - insufficient rights for this function');
  // Helper.broadcast('Access Denied - insufficient rights for this function');
  return '/error500';
}
